import { render, staticRenderFns } from "./ProvisioningHistoryGraph.vue?vue&type=template&id=2f1dc51a&scoped=true&"
import script from "./ProvisioningHistoryGraph.vue?vue&type=script&lang=js&"
export * from "./ProvisioningHistoryGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1dc51a",
  null
  
)

export default component.exports